module.exports = __webpack_public_path__ + "static/media/unique-mobile.20f11c51.svg";